import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pool-membership" }
const _hoisted_2 = { class: "membership-toolbar" }
const _hoisted_3 = { class: "cluster-hub" }
const _hoisted_4 = {
  key: 0,
  class: "pool-note"
}
const _hoisted_5 = {
  key: 1,
  class: "pool-grid"
}
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "pool-heading" }
const _hoisted_8 = { class: "pool-summary" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { class: "pool-capacity" }
const _hoisted_14 = { class: "pool-nodes" }
const _hoisted_15 = ["aria-label"]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "node-state" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScopeFilterDropdown = _resolveComponent("ScopeFilterDropdown")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
        _createElementVNode("strong", null, "Node pools"),
        _createElementVNode("span", null, "Membership from node labels · connectors do not represent network traffic")
      ], -1)),
      (_ctx.keys.length)
        ? (_openBlock(), _createBlock(_component_ScopeFilterDropdown, {
            key: 0,
            value: _ctx.activeLabel,
            options: _ctx.labelOptions,
            label: "Pool label",
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedLabel = $event))
          }, null, 8, ["value", "options"]))
        : _createCommentVNode("", true)
    ]),
    _cache[5] || (_cache[5] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      _cache[2] || (_cache[2] = _createElementVNode("i", {
        class: "icon icon-kubernetes",
        "aria-hidden": "true"
      }, null, -1)),
      _createElementVNode("strong", null, _toDisplayString(_ctx.clusterName || _ctx.clusterId || 'Current cluster'), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.nodes.length) + " loaded nodes · " + _toDisplayString(_ctx.pools.length) + " " + _toDisplayString(_ctx.pools.length === 1 ? 'pool group' : 'pool groups'), 1)
    ]),
    _cache[6] || (_cache[6] = _createTextVNode()),
    (!_ctx.activeLabel && _ctx.nodes.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, "\n      No pool label found in the loaded nodes. Unassigned shows membership that has not been labelled.\n    "))
      : _createCommentVNode("", true),
    _cache[7] || (_cache[7] = _createTextVNode()),
    (_ctx.pools.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pools, (pool) => {
            return (_openBlock(), _createElementBlock("section", {
              key: pool.key,
              class: "pool-card",
              "aria-label": `Node pool ${pool.label}`
            }, [
              _createElementVNode("div", _hoisted_7, [
                _cache[3] || (_cache[3] = _createElementVNode("i", {
                  class: "icon icon-folder",
                  "aria-hidden": "true"
                }, null, -1)),
                _createElementVNode("strong", null, _toDisplayString(pool.label), 1),
                _createElementVNode("span", null, _toDisplayString(pool.nodes.length) + " nodes", 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                (pool.missing)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "No pool label"))
                  : _createCommentVNode("", true),
                _cache[4] || (_cache[4] = _createTextVNode()),
                _createElementVNode("span", null, _toDisplayString(pool.overview.ready) + " ready", 1),
                (pool.overview.notReady)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(pool.overview.notReady) + " not ready", 1))
                  : _createCommentVNode("", true),
                (pool.overview.unknown)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(pool.overview.unknown) + " unknown", 1))
                  : _createCommentVNode("", true),
                (pool.overview.cordoned)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(pool.overview.cordoned) + " cordoned", 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_13, [
                _createTextVNode("\n          Reported allocatable: " + _toDisplayString(_ctx.capacity(pool.overview)), 1),
                _createElementVNode("span", null, _toDisplayString(pool.overview.cpuReported) + "/" + _toDisplayString(pool.nodes.length) + " CPU reports · " + _toDisplayString(pool.overview.memoryReported) + "/" + _toDisplayString(pool.nodes.length) + " memory reports", 1)
              ]),
              _createElementVNode("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pool.nodes, (node, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: node.metadata?.name || index
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["readiness-dot", { ready: _ctx.readiness(node) === 'Ready', unavailable: _ctx.readiness(node) === 'Unknown' }]),
                      "aria-label": _ctx.readiness(node)
                    }, null, 10, _hoisted_15),
                    (_ctx.clusterId && node.metadata?.name)
                      ? (_openBlock(), _createBlock(_component_RouterLink, {
                          key: 0,
                          to: _ctx.location(node)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(node.metadata.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(node.metadata?.name || 'Node name unavailable'), 1)),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(node.spec?.unschedulable ? 'Cordoned' : _ctx.readiness(node)), 1)
                  ]))
                }), 128))
              ])
            ], 8, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}